// extracted by mini-css-extract-plugin
export default {"input":"EnterNewPassword_input__163M4"};